module.exports = __webpack_public_path__ + "static/media/TN-Men-Wallets-2.0.2fac1976.svg";